import { TOASTIFY_STATUS } from "../constants/application";
import { GENERIC_ERROR_MESSAGE } from "../constants/common";
import { AUTHENTICATION_TOKEN } from "../constants/storage";
import { getCookie } from "../helpers/browserStorage";
import { notifyToaster } from "../helpers/common";
import { getJSON, postJSON } from "../utils/fetch";

const API_ENDPOINT = `${process.env.REACT_APP_API_HOST}/api/v6/fleet`;
const CUSTOMERS = "customers";
const DRIVERS = "drivers";

export const addDriver = async (data) => {
  try {
    const response = await postJSON(
      `${API_ENDPOINT}/${CUSTOMERS}`,
      data,
      {
        Authorization: getCookie(AUTHENTICATION_TOKEN),
      }
    );

    if (response.error) {
      notifyToaster(response.error || GENERIC_ERROR_MESSAGE, {
        type: TOASTIFY_STATUS.error,
      });
      throw new Error(response.error);
    }

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getDrivers = async ({ fleetId }) => {
  try {
    const response = await getJSON(
      `${API_ENDPOINT}/${DRIVERS}`,
      {
        fleet_id: fleetId,
      },
      {
        Authorization: getCookie(AUTHENTICATION_TOKEN),
      }
    );

    if (response.error) {
      notifyToaster(response.error || GENERIC_ERROR_MESSAGE, {
        type: TOASTIFY_STATUS.error,
      });
      throw new Error(response.error);
    }

    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
